module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color.jpg.pvr.dd1ff778.ktx";